import { observer } from "mobx-react-lite";
import React from "react";
import { Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { AccountsReceivableReportItemDto } from "../../../../app/models/accountsReceivable";
import { formatCurrency } from "../../../../app/common/util/functions";

interface Props {
    allValues: AccountsReceivableReportItemDto[];
}

export default observer(function AccountsReceivablePrintSummary({
    allValues,
}: Props) {
    const { t } = useTranslation(["common", "reports"]);

    return (
        <>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={5}>
                        {t("customer", { ns: "common" })}
                    </Table.HeaderCell>
                    <Table.HeaderCell width={3}>
                        {t("accountNumber", { ns: "accountsReceivable" })}
                    </Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="right">
                        {t("creditLimit", { ns: "accountsReceivable" })}
                    </Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="right">
                        {t("balanceDue", { ns: "accountsReceivable" })}
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {allValues.map((ar, idx) => (
                    <Table.Row key={idx}>
                        <Table.Cell
                            className="hoveredLink"
                            onClick={() => window.open(`/customer/${ar.customerId}`, "_blank")}
                            data-label={`${t("name", { ns: "common" })}:`}
                        >
                            {ar.companyName ? ar.companyName : ar.customerName}
                        </Table.Cell>
                        <Table.Cell data-label={`${t("accountNumber", { ns: "accountsReceivable" })}:`}>
                            {ar.accountNumber}
                        </Table.Cell>
                        <Table.Cell
                            data-label={`${t("creditLimit", {
                                ns: "accountsReceivable",
                            })}:`}
                            textAlign="right"
                        >
                            {formatCurrency(ar.creditLimit ?? 0)}
                        </Table.Cell>
                        <Table.Cell
                            data-label={`${t("balanceDue", { ns: "accountsReceivable" })}:`}
                            textAlign="right"
                        >
                            {formatCurrency(ar.balanceDue ?? 0)}
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </>
    );
});
